<script>
  /* global Global */
  export let value;

  let width;

  // eslint-disable-next-line no-magic-numbers
  $: width = (value.inning - 0.5) / 9 * 100;

  const projectStyle = Global.project.style;
</script>

<div class='live-stripe' class:live-stripe-old={projectStyle === 'old' || projectStyle === 'sharp'}>
  <div class='live-stripe-indicator'
    style='--live-stripe-indicator-width: {width}%'
    class:live-stripe-indicator-red={value.color === 'red'}
    class:live-stripe-indicator-yellow={value.color === 'yellow'}
    class:live-stripe-indicator-green={value.color === 'green'}
    class:live-stripe-indicator-blue={value.color === 'blue'}/>
</div>

<style>
  .live-stripe {
    width: 100%;
    height: 5px;

    border-radius: var(--radius-sm);

    background: var(--grey-3);
  }

  .live-stripe-indicator {
    width: min(var(--live-stripe-indicator-width), 100%);
    height: 100%;

    border-radius: var(--radius-sm);

    background: var(--primary);
  }

  .live-stripe-indicator-red {
    background: linear-gradient(135deg, var(--red), var(--dark-red));
  }

  .live-stripe-old .live-stripe-indicator-red {
    background: var(--red);
  }

  .live-stripe-indicator-yellow {
    background: linear-gradient(135deg, var(--yellow), var(--orange));
  }

  .live-stripe-old .live-stripe-indicator-yellow {
    background: var(--yellow);
  }

  .live-stripe-indicator-green {
    background: linear-gradient(135deg, var(--green), var(--dark-green));
  }

  .live-stripe-old .live-stripe-indicator-green {
    background: var(--green);
  }

  .live-stripe-indicator-blue {
    background: linear-gradient(135deg, var(--blue), var(--dark-blue));
  }

  .live-stripe-old .live-stripe-indicator-blue {
    background: var(--blue);
  }

  :global(body.dark) .live-stripe {
    background: var(--grey-7);
  }

  :global(body.dark) .live-stripe-indicator-red {
    background: linear-gradient(135deg, var(--red-dark), var(--dark-red-dark));
  }

  :global(body.dark) .live-stripe-old .live-stripe-indicator-red {
    background: var(--red-dark);
  }

  :global(body.dark) .live-stripe-indicator-yellow {
    background: linear-gradient(135deg, var(--yellow-dark), var(--orange-dark));
  }

  :global(body.dark) .live-stripe-old .live-stripe-indicator-yellow {
    background: var(--yellow-dark);
  }

  :global(body.dark) .live-stripe-indicator-green {
    background: linear-gradient(135deg, var(--green-dark), var(--dark-green-dark));
  }

  :global(body.dark) .live-stripe-old .live-stripe-indicator-green {
    background: var(--green-dark);
  }

  :global(body.dark) .live-stripe-indicator-blue {
    background: linear-gradient(135deg, var(--blue-dark), var(--dark-blue-dark));
  }

  :global(body.dark) .live-stripe-old .live-stripe-indicator-blue {
    background: var(--blue-dark);
  }
</style>
